<template>
	<div class="item" :class="{orderlist}">
		<div class="product">
			<div class="cells">
				<div class="cell-title" v-text="title"/>
				<div class="cell-total" v-text="price"/>
				<a class="cell-remove" @click="remove">
					<div class="icon" v-html="require('@/assets/icons/times-regular.svg')"/>
				</a>
			</div>

			<div class="vendor" v-text="vendor"/>

			<div class="variants">
				<variant v-for="item in line_items" :key="item.id" v-bind="item"/>
			</div>
		</div>
	</div>
</template>

<script>
import {price} from "@/modules/utils";
import variant from "./variant.vue";

export default {
	components: {variant},
	props: {
		id: {type: Number, required: true},
		title: {type: String, required: true},
		vendor: {type: String, required: true},
		line_items: {type: Array, required: true},
		orderlist: {type: Boolean, required: false}
	},
	computed: {
		price: (t) => price(t.line_items.reduce((sum, x) => sum + x.total_price, 0))
	},
	methods: {
		remove() {
			this.$store.dispatch("cart/removeProduct", {productId: this.id});
		}
	}
};
</script>

<style lang="scss" scoped>
.item {
	background-color: #FAFAFC;
	padding: 0.5em;
	margin-bottom: em(8);

	&.orderlist {
		background-color: transparent;
		padding: 0;
		border-bottom: 1px solid #D2D6DA;
		padding: 0.5em 0 0.75em;
		margin-left: -8px;
	}

	.product {
		.cells {
			.cell {
				&-title {
					font-size: em(14);
					font-weight: 500;
				}
				&-total {
					font-size: em(14);
					font-weight: 500;
				}
				&-remove {
					.icon {
						/deep/ svg {
							width: 8px;
							height: 12px;
						}
					}
				}
			}
		}

		.vendor {
			font-size: 0.7em;
			font-weight: 400;
			font-style: italic;
			padding-left: 8px;
			margin-bottom: 0.5em;
		}
	}

	/deep/ {
		.cells {
			width: 100%;
			display: flex;
			align-items: center;

			> div, a {
				padding: 6px 8px;
			}

			.cell {
				&-total {
					margin-left: auto;
				}
				&-remove {
					width: 10px;
					display: flex;
					justify-content: center;

					.icon {
						display: block;
					}
				}
			}
		}
	}
}
</style>
